// /home/oh33090489/real-estate-app/frontend/src/components/HoList.jsx

import React, { useMemo } from "react";
import "./HoList.css";

export default function HoList({ items = [], onSelect }) {
  const sorted = useMemo(() => {
    return [...items].sort((a, b) => {
      return (
        (a.estate_dong || "").localeCompare(b.estate_dong || "") ||
        (Number(a.estate_ho) || 0) - (Number(b.estate_ho) || 0) ||
        Number(a.floor) - Number(b.floor)
      );
    });
  }, [items]);

// 접미사 중복 방지 함수
  const withSuffix = (val, suffix) => {
    if (val === null || val === undefined) return null;
    const s = String(val).trim();
    if (!s || s === "0") return null;
    return s.endsWith(suffix) ? s : `${s}${suffix}`;
  };

// 호수 표시 텍스트 결정 로직 (참조 필드 확장)
  const getHoDisplay = (it) => {
    // it.ho 또는 it.estate_ho 중 유효한 값을 먼저 찾음
    const rawHo = String(it.estate_ho || it.ho || "").trim();
    const ho = (rawHo !== "" && rawHo !== "0") ? withSuffix(rawHo, "호") : null;
    
    if (ho) return ho;

    // 호수 정보가 전혀 없을 경우 층 정보로 대체
    const floorEtc = String(it.floor_etc || "").trim();
    if (floorEtc !== "" && floorEtc !== "0") return floorEtc;

    const floor = String(it.floor || "").trim();
    return (floor !== "" && floor !== "0") ? `${floor}층` : "정보없음";
  };

  return (
    <div className="ho-list">
      {sorted.map(it => {
        const dong = withSuffix(it.estate_dong, "동");
        return (
          <div
            key={it.estate_no}
            className="ho-row"
            onClick={() => onSelect(it)}
          >
            <div className="ho-main">
              <b>
                {dong && `${dong} `}
                {getHoDisplay(it)}
              </b>
            </div>
          </div>
        );
      })}
    </div>
  );
}
